@if (languageChange$ | async; as _lang) {
  <ng-container *transloco="let t">
    <!-- begin:: Header -->
    <div class="offcanvas-header px-5 py-3 border border-bottom-2">
      <h4 class="offcanvas-title" transloco="label_quick_cart"></h4>
      <button type="button" class="btn-close btn btn-light-secondary rounded" aria-label="Close" (click)="activeOffcanvas.dismiss()"></button>
    </div>
    <!-- end:: Header -->
    <!-- begin:: Body -->
    <div class="offcanvas-body card-scroll px-3 py-1 responsive-scroll">
      @if (!isCartEmpty()) {
        @if (isloading()) {
          <div class="text-center py-5">
            <span class="spinner-border spinner-border-sm me-2"></span>
            <span transloco="sentence_please_wait_loading"> </span>
          </div>
        } @else {
          <!-- begin:: Products list -->
          @if (products.length > 0 || resellerProducts.length > 0) {
            <mat-tab-group [disableRipple]="true" [animationDuration]="'0ms'">
              <mat-tab [label]="t('label_cart')">
                <!-- begin:: Normal cart items -->
                @if (products.length > 0) {
                  <section>
                    <ng-container *ngTemplateOutlet="cartListTpl; context: { list: products, companyid: null, source: 'NORMAL', form: getCheckoutForm('NORMAL', null) }"> </ng-container>
                  </section>
                }
                <!-- end:: Normal cart items -->

                <!-- begin:: Reseller -->
                @if (resellerProducts.length > 0) {
                  <section>
                    <div class="separator my-6"></div>
                    @for (group of resellerProducts; track group.companyId) {
                      <div class="mb-6">
                        <h5 class="mb-3">
                          {{ group.companyName }}
                        </h5>
                        <ng-container *ngTemplateOutlet="cartListTpl; context: { list: group.items, companyid: group.companyId, source: 'RESELLER', form: getCheckoutForm('RESELLER', group.companyId) }"> </ng-container>
                      </div>
                      <div class="separator my-6"></div>
                    }
                  </section>
                }
                <!-- end:: Reseller -->
              </mat-tab>
              <mat-tab [label]="t('label_find_active_cart')">
                <ng-container *ngTemplateOutlet="activeCartSearchTpl"></ng-container>
              </mat-tab>
            </mat-tab-group>
          }
          <!-- end:: Products list -->
        }
      } @else {
        <ng-container *ngTemplateOutlet="activeCartSearchTpl"></ng-container>
      }
    </div>
    <!-- begin:: Body -->

    <!-- begin:: Cart items list template -->
    <ng-template #cartListTpl let-list="list" let-companyid="companyid" let-source="source" let-form="form">
      <ul class="list-unstyled">
        <!-- begin:: Products List -->
        @for (row of list; track row; let i = $index) {
          @let company = row?.reseller?.company ?? row?.company;

          <li class="py-5 border-bottom">
            <div class="col-12 d-flex-inline d-md-flex text-start">
              <!-- being:: Image & Info -->
              <div class="d-flex justify-content-md-end justify-content-start flex-sm-column-reverse flex-md-row-reverse col-md-10 col-sm-12">
                <!-- begin:: Part Info -->
                <div class="d-flex justify-content-start flex-column ms-md-2 me-2 me-md-0 w-100">
                  <!-- Part Stock No and Description -->
                  <a
                    [gaSelectItem]="(row?.context?.analytics)"
                    [routerLink]="[(row?.context?.route) | PdpUrl: row]"
                    [title]="(row?.part?.general?.item)"
                    class="fw-semibold link-visited"
                  >
                    {{ row?.part?.general?.item }} | {{ row?.code?.part?.pc?.pt3 }}
                  </a>
                  <!-- SBR code name -->
                  @if (row?.code?.vehicle?.code_vc?.text; as _sbr_code_name) {
                    <div class="fs-8">
                      {{ _sbr_code_name }}
                    </div>
                  }
                  <!-- Part & Vehicle Info -->
                  @if (row?.vehicle?.general?.description; as _vehicle_description) {
                    <div class="small text-uppercase">
                      {{ _vehicle_description }}
                    </div>
                  }
                  <div class="text-uppercase small">
                    @if (row?.part?.general?.position[1]; as _part_pos) {
                      <span class="me-1">{{ _part_pos }}</span>
                    }
                    @if (row?.part?.general?.description; as _part_info) {
                      <span>{{ _part_info }}</span>
                    }
                  </div>
                  <!-- Company Info -->
                  <div>
                    <div>
                      {{ company?.name }}
                      <span class="small text-gray-800 ms-1">({{ company?.country }})</span>
                    </div>
                    <!-- Ratings -->
                    @if (!env.settings.hideCompanyReviews) {
                      @if (company?.review?.recommend; as _rating) {
                        <div class="text-muted small d-flex">
                          <i class="ki-duotone ki-like fs-5">
                            <span class="path1"></span>
                            <span class="path2"></span>
                          </i>
                          {{ _rating | companyRating }}
                        </div>
                      }
                      <!-- Order handling time -->
                      @if (company?.review?.median_handle_time; as handle_time) {
                        <div class="text-muted small d-flex" [matTooltip]="t('sentence_order_handling_time_info')" [matTooltipShowDelay]="600">
                          <i class="ki-duotone ki-time fs-5"><span class="path1"></span><span class="path2"></span></i>
                          <span class="first-letter-only">{{ handle_time | orderHandlingTime }}</span>
                        </div>
                      }
                    }
                  </div>
                  <!-- Part type ie. Used,Economy, New original, Remanufactured -->
                  @if (row?.part?.general?.type_description; as _part_type_description) {
                    <div class="fs-8 d-flex align-content-center my-1">
                      @switch (row?.part?.general?.type_id) {
                        <!-- Economy -->
                        @case (1) {
                          <span class="fs-9 badge badge-light-warning">{{ _part_type_description }}</span>
                        }
                        <!-- Refurbished / Remanufactured -->
                        @case (2) {
                          <span class="fs-9 badge badge-dark">{{ _part_type_description }}</span>
                        }
                        <!-- New Original -->
                        @case (3) {
                          <span class="fs-9 badge badge-primary">{{ _part_type_description }}</span>
                        }
                        <!-- Used -->
                        @default {
                          <span class="fs-9 badge badge-secondary">{{ _part_type_description }}</span>
                        }
                      }
                      <!-- Seller country -->
                      <span class="fs-9 badge badge-secondary badge-sm ms-1">
                        <img
                          class="h-14px w-auto rounded me-1"
                          [title]="(row?.company?.country) + ' flag'"
                          [alt]="(row?.company?.country)"
                          [src]="'./assets/media/flags/' + (row?.company?.flag) + '.svg'"
                        />
                        {{ row?.company?.postal_city }}, {{ row?.company?.country }}
                      </span>
                    </div>
                  }
                  <!-- Part Already booked by another customer warning message -->
                  @if (row?.booking?.reference) {
                    <div class="text-danger small my-1">
                      <i class="fa fa-exclamation-triangle text-danger me-1"></i>
                      <span transloco="sentence_part_is_already_booked_to_a_customer"></span>
                    </div>
                  }
                  <!-- The store is temporarily closed -->
                  @if (company?.on_holiday) {
                    <div class="text-danger small my-1">
                      <i class="fa fa-exclamation-triangle text-danger me-1"></i>
                      <span transloco="paragraph_store_is_temporarily_closed"></span>
                    </div>
                  }
                  <!-- The part must be removed from the car before delivery -->
                  @if (!row?.part?.storage?.demounted) {
                    <div class="text-danger small my-1">
                      <i class="fa fa-exclamation-triangle text-danger me-1"></i>
                      <span transloco="sentence_part_must_be_removed_before_delivery"></span>
                    </div>
                  }
                </div>
                <!-- begin:: Part Info -->
                <!-- begin:: Image -->
                <div class="symbol symbol-100px">
                  <a [gaSelectItem]="(row?.context?.analytics)" [routerLink]="[(row?.context?.route) | PdpUrl: row]" [title]="(row?.part?.general?.item)">
                    @if (row?.part?.image[0]; as _imageUrl) {
                      <div class="symbol-label" [style]="{ 'background-image': _imageUrl | imageBgURL }"></div>
                    } @else {
                      <div class="symbol-label" style="background-image: url(&quot;./assets/media/general/no-image.jpg&quot;)"></div>
                    }
                  </a>
                </div>
                <!-- end:: Image -->
              </div>
              <!-- end:: Image & Info -->
              <!-- begin:: Action Buttons -->
              <div class="col-md-1 col-sm-12">
                <!-- begin:: View -->
                <a
                  [gaSelectItem]="(row?.context?.analytics)"
                  [routerLink]="[(row?.context?.route) | PdpUrl: row]"
                  title=""
                  class="btn btn-bg-light btn-active-color-primary btn-sm me-1 mb-1 bg-light-primary bg-opacity-90"
                >
                  <span class="d-inline-block d-sm-none text-primary me-1 me-lg-0" transloco="label_details"></span>
                  <span [inlineSVG]="'assets/media/icons/bootstrap/info-circle.svg'" class="svg-icon svg-icon-primary"></span>
                </a>
                <!-- end:: View -->
                <!-- begin:: Delete Btn -->
                <button type="button" (click)="onDeleteItem((row?.id), (row?.context?.analytics))" class="btn btn-bg-light btn-active-color-danger btn-sm me-1 mb-1 bg-light-danger bg-opacity-90">
                  <span class="d-inline-block d-sm-none text-danger me-1 me-lg-0" transloco="label_delete"></span>
                  <span [inlineSVG]="'assets/media/icons/duotune/general/gen027.svg'" class="svg-icon svg-icon-danger"></span>
                </button>
                <!-- end:: Delete Btn -->
              </div>
              <!-- end:: Action Buttons -->
            </div>
          </li>
        }
        <!-- end:: Products List -->
      </ul>
      <!--begin::Checkout Form -->
      <form class="form" [formGroup]="form" role="form" (ngSubmit)="onNavigateToCheckout(list, companyid, source, form)">
        <div class="form-group mt-4">
          <mat-form-field class="mat-form-field-fluid">
            <mat-label transloco="label_enter_email"></mat-label>
            <input matInput type="email" formControlName="email" autocomplete="email" />
            @if (form.controls.email.errors?.required) {
              <mat-error>
                <span transloco="label_required_field"></span>
              </mat-error>
            }
            @if (form.controls.email.errors?.email) {
              <mat-error>
                <strong transloco="sentence_field_is_not_valid"></strong>
              </mat-error>
            }
          </mat-form-field>
        </div>
        <!--begin::Action-->
        <div class="form-group">
          <!-- begin:: Checkout button -->
          <button type="submit" [disabled]="loadingOnNavigateToCheckout" class="btn btn-primary btn-lg w-100">
            <span transloco="label_to_checkout"></span>
            @if (loadingOnNavigateToCheckout) {
              <span class="spinner-border spinner-border-sm ms-2"></span>
            }
            <!--begin::Svg Icon-->
            @if (!loadingOnNavigateToCheckout) {
              <span [inlineSVG]="'assets/media/icons/duotune/arrows/arr024.svg'" class="svg-icon svg-icon-2"></span>
            }
            <!--end::Svg Icon-->
          </button>
          <!-- end:: Checkout button -->
        </div>
        <!--end::Action-->

        <!-- Email notification info -->
        <p class="text-muted small my-2" transloco="paragraph_cart_email_notification_info"></p>
      </form>
      <!--end::Checkout Form-->
    </ng-template>
    <!-- end:: Cart items list template -->

    <!-- begin:: Active Cart Search Template -->
    <ng-template #activeCartSearchTpl>
      <section class="my-4">
        <h6 transloco="sentence_already_have_a_shopping_cart"></h6>
        <!--begin::Search Form -->
        <form class="form" [formGroup]="cartSearchForm" role="form" (ngSubmit)="onSearch()">
          <div class="form-group mt-4">
            <mat-form-field class="mat-form-field-fluid">
              <mat-label transloco="sentence_enter_email_or_shopping_cart_id"></mat-label>
              <input matInput type="text" formControlName="searchText" autocomplete="email" />
              @if (cartSearchForm.controls.searchText.errors?.required) {
                <mat-error>
                  <span transloco="label_required_field"></span>
                </mat-error>
              }
            </mat-form-field>
          </div>
          <!--begin::Action-->
          <div class="form-group">
            <button [disabled]="isSearching()" type="subit" class="btn btn-primary w-100">
              <!--begin::Svg Icon-->
              <span [inlineSVG]="'assets/media/icons/duotune/general/gen021.svg'" class="svg-icon svg-icon-2 me-1"></span>
              <!--end::Svg Icon-->
              <span transloco="label_search"></span>
              @if (isSearching()) {
                <span class="spinner-border spinner-border-sm ms-2"></span>
              }
            </button>
          </div>
          <!--end::Action-->
        </form>
        <!--end::Search Form-->
        <!-- begin:: Cart Found -->
        <app-existing-carts [previousCarts]="previousCarts" [customerEmail]="customerEmail"></app-existing-carts>
        <!-- end:: Cart Found -->
      </section>
      <!--begin::Menu separator-->
      <div class="separator my-4"></div>
      <!--end::Menu separator-->

      <!-- begin:: Empty cart -->
      @if (previousCarts.length == 0) {
        <section>
          <div class="d-flex align-items-center bg-light-danger rounded p-5 mb-7">
            <!--begin::Title-->
            <div class="flex-grow-1 me-2">
              <span class="fw-bold text-gray-800 text-hover-primary fs-6" transloco="sentence_your_cart_is_currently_empty"></span>
              <span class="text-muted fw-semibold d-block" transloco="paragraph_before_proceeding_to_checkout"></span>
            </div>
            <!--end::Title-->
          </div>
        </section>
      }
      <!-- end:: Empty cart -->
    </ng-template>
    <!-- end:: Active Cart Search Template -->
  </ng-container>
}
